
  <div class="header">
    <div class="top-info">
      <div class="bg-image"></div>
      <div class="container-xl custom-container">
        <div [class.ns-pb-0]="isMobile && !isPledge" class="top-wrapper">
          <h1 [class.ns-mb-4]="isMobile && isPledge">{{ 'BROWSE_PAGE.page_title' | translate }}</h1>
          <h2>{{ (isPledge ? 'BROWSE_PAGE.page_subtitle_w_pledge' :
            'BROWSE_PAGE.page_subtitle_wo_pledge') | translate:{company: user?.company_name} }}</h2>
        </div>
      </div>
    </div>
  </div>
  <div [class.ns-mt-0]="isMobile && !isPledge" class="main-container">
    <!--#region VOTES COUNTER -->
    <div *ngIf="displayVoteCounter && isPledge" class="votes-counter-container">
      <div
           [padding]="5"
           [tooltipText]="'BROWSE_PAGE.vote_counter_tooltip' | translate:{company: user?.company_name}"
           [tooltipWidth]="this.isMobile ? 160 : 300"
           [left]="false"
           [top]="false"
           class="votes-counter"
           nsTooltip>
        <ng-container *ngIf="votesAvailable > 0">
          <div>
            <span>{{ votesAvailable }}</span>
            {{ isMobile ?
            ('BROWSE_PAGE.votes_available' | translate:{plural: 's'}) :
            ('BROWSE_PAGE.votes_available' | translate:{plural: votesAvailable > 1 ? 's' : ''} | lowercase)}}
          </div>
          <img *ngFor="let i of [].constructor(votesAvailable)" src="assets/icons/vote_filled.svg">
          <img *ngFor="let i of [].constructor(5 - votesAvailable)" src="assets/icons/vote_available.svg">
        </ng-container>
        <ng-container *ngIf="votesAvailable === 0">
          <div [class]="'ns-mr-auto'">{{ 'BROWSE_PAGE.all_votes_assigned' | translate }}</div>
          <ns-button
            (callback$)="manageVotes()"
            [classes]="'ns-ml-16'"
            [text]="'BROWSE_PAGE.manage_votes' | translate"
            [type]="isMobile ?
            Constants.BUTTON_TYPE_DEFAULT_YELLOW_FILLED_S : Constants.BUTTON_TYPE_DEFAULT_YELLOW_SOLID_M"
          ></ns-button>
        </ng-container>
      </div>
    </div>
    <div *ngIf="isMobile" class="spacer"></div>
    <!--#endregion -->
    <!--#region PROJECT FILTERS BY NORTH STAR & SORT -->
    <div class="north-stars-block" [class.ns-mt-126]="!displayVoteCounter && !isMobile">
      <div (mousedown)="startScrolling('left')" (mouseleave)="stopScrolling()" (mouseup)="stopScrolling()"
           *ngIf="!isMobile && hasHorizontalScroll" class="left-button">
        <i class="fa-solid fa-angle-left"></i>
      </div>
      <div *ngIf="(!isMobile && hasHorizontalScroll) || isMobile" [style.width.px]="!isMobile ? categoriesSliderWidth:
    undefined" class="mask"></div>
      <div #scrollableDiv [style.width.px]="!isMobile && hasHorizontalScroll ? categoriesSliderWidth: undefined"
           class="buttons-container no-scrollbar">
        <div (click)="filterByNorthStar(ProjectConstants.CAT_ALL)"
             [class.active]="selectedNorthStar === ProjectConstants.CAT_ALL"
             [class.disabled]="this.filteredProjects?.length === 0"
             class="g-category-button ns-ml-16">
          <div [innerHTML]="svgSanitizer(SVG.CAT_ALL)" class="svg"></div>
          <div
            class="name">{{ "BROWSE_PAGE." + ProjectConstants.CAT_ALL + "_browsepage" | translate | capitalize }}</div>
        </div>
        <div (click)="filterByNorthStar(ProjectConstants.CAT_REFORESTATION)" *ngIf="!!northStarProjectCounts[ProjectConstants.CAT_REFORESTATION]"
             [class.active]="selectedNorthStar === ProjectConstants.CAT_REFORESTATION"
             [class.disabled]="!projectWithNorthStarInFilter(ProjectConstants.CAT_REFORESTATION)"
             class="g-category-button">
          <div [innerHTML]="svgSanitizer(SVG.CAT_REFORESTATION)" class="svg"></div>
          <div
            class="name">{{ "BROWSE_PAGE." + ProjectConstants.CAT_REFORESTATION + "_browsepage" | translate | capitalize }}</div>
        </div>
        <div (click)="filterByNorthStar(ProjectConstants.CAT_BIODIVERSITY)" *ngIf="!!northStarProjectCounts[ProjectConstants.CAT_BIODIVERSITY]"
             [class.active]="selectedNorthStar === ProjectConstants.CAT_BIODIVERSITY"
             [class.disabled]="!projectWithNorthStarInFilter(ProjectConstants.CAT_BIODIVERSITY)"
             class="g-category-button">
          <div [innerHTML]="svgSanitizer(SVG.CAT_BIODIVERSITY)" class="svg"></div>
          <div
            class="name">{{ "BROWSE_PAGE." + ProjectConstants.CAT_BIODIVERSITY + "_browsepage" | translate | capitalize }}</div>
        </div>
        <div (click)="filterByNorthStar(ProjectConstants.CAT_EDUCATION)" *ngIf="!!northStarProjectCounts[ProjectConstants.CAT_EDUCATION]"
             [class.active]="selectedNorthStar === ProjectConstants.CAT_EDUCATION"
             [class.disabled]="!projectWithNorthStarInFilter(ProjectConstants.CAT_EDUCATION)"
             class="g-category-button">
          <div [innerHTML]="svgSanitizer(SVG.CAT_EDUCATION)" class="svg"></div>
          <div
            class="name">{{ "BROWSE_PAGE." + ProjectConstants.CAT_EDUCATION + "_browsepage" | translate | capitalize }}</div>
        </div>
        <div (click)="filterByNorthStar(ProjectConstants.CAT_ZERO_WASTE)" *ngIf="!!northStarProjectCounts[ProjectConstants.CAT_ZERO_WASTE]"
             [class.active]="selectedNorthStar === ProjectConstants.CAT_ZERO_WASTE"
             [class.disabled]="!projectWithNorthStarInFilter(ProjectConstants.CAT_ZERO_WASTE)"
             class="g-category-button">
          <div [innerHTML]="svgSanitizer(SVG.CAT_ZERO_WASTE)" class="svg"></div>
          <div
            class="name">{{ "BROWSE_PAGE." + ProjectConstants.CAT_ZERO_WASTE + "_browsepage" | translate | capitalize }}</div>
        </div>
        <div (click)="filterByNorthStar(ProjectConstants.CAT_INCLUSION)" *ngIf="!!northStarProjectCounts[ProjectConstants.CAT_INCLUSION]"
             [class.active]="selectedNorthStar === ProjectConstants.CAT_INCLUSION"
             [class.disabled]="!projectWithNorthStarInFilter(ProjectConstants.CAT_INCLUSION)"
             class="g-category-button">
          <div [innerHTML]="svgSanitizer(SVG.CAT_INCLUSION)" class="svg"></div>
          <div
            class="name">{{ "BROWSE_PAGE." + ProjectConstants.CAT_INCLUSION + "_browsepage" | translate | capitalize }}</div>
        </div>
        <div (click)="filterByNorthStar(ProjectConstants.CAT_CARBON_OFFSET)" *ngIf="!!northStarProjectCounts[ProjectConstants.CAT_CARBON_OFFSET]"
             [class.active]="selectedNorthStar === ProjectConstants.CAT_CARBON_OFFSET"
             [class.disabled]="!projectWithNorthStarInFilter(ProjectConstants.CAT_CARBON_OFFSET)"
             class="g-category-button">
          <div [innerHTML]="svgSanitizer(SVG.CAT_CARBON_OFFSET)" class="svg"></div>
          <div
            class="name">{{ "BROWSE_PAGE." + ProjectConstants.CAT_CARBON_OFFSET + "_browsepage" | translate | capitalize }}</div>
        </div>
        <div (click)="filterByNorthStar(ProjectConstants.CAT_HEALTH)" *ngIf="!!northStarProjectCounts[ProjectConstants.CAT_HEALTH]"
             [class.active]="selectedNorthStar === ProjectConstants.CAT_HEALTH"
             [class.disabled]="!projectWithNorthStarInFilter(ProjectConstants.CAT_HEALTH)"
             class="g-category-button">
          <div [innerHTML]="svgSanitizer(SVG.CAT_HEALTH)" class="svg"></div>
          <div
            class="name">{{ "BROWSE_PAGE." + ProjectConstants.CAT_HEALTH + "_browsepage" | translate | capitalize }}</div>
        </div>
        <div (click)="filterByNorthStar(ProjectConstants.CAT_DIVERSE)" *ngIf="!!northStarProjectCounts[ProjectConstants.CAT_DIVERSE]"
             [class.active]="selectedNorthStar === ProjectConstants.CAT_DIVERSE"
             [class.disabled]="!projectWithNorthStarInFilter(ProjectConstants.CAT_DIVERSE)"
             class="g-category-button ns-mr-16">
          <div [innerHTML]="svgSanitizer(SVG.CAT_DIVERSE)" class="svg"></div>
          <div
            class="name">{{ "BROWSE_PAGE." + ProjectConstants.CAT_DIVERSE + "_browsepage" | translate | capitalize }}</div>
        </div>
      </div>
      <div (mousedown)="startScrolling('right')" (mouseleave)="stopScrolling()" (mouseup)="stopScrolling()"
           *ngIf="!isMobile && hasHorizontalScroll" class="right-button">
        <i class="fa-solid fa-angle-right"></i>
      </div>
      <div *ngIf="!isMobile" class="button-filter-wrapper">
        <div *ngIf="selectedRegionTags.length > 0 || selectedTopicTags.length > 0 || selectedVettingType !== undefined"
             class="active-filter-dot"></div>
        <ns-button
          (callback$)="toggleFilters()"
          *ngIf="!isMobile"
          [classes]="'ns-ml-20 ns-p-20x10'"
          [faIcon]="'fa-solid fa-sliders'"
          [iconClasses]="'ns-mr-10'"
          [iconRightSide]="false"
          [isActive]="selectedRegionTags.length > 0 || selectedTopicTags.length > 0 || selectedVettingType !==
          undefined"
          [text]="'BROWSE_PAGE.filter' | translate"
          [type]="Constants.BUTTON_TYPE_DEFAULT_DARK_BLUE_STROKE_M">
        </ns-button>
      </div>
    </div>
    <div *ngIf="isMobile" class="d-flex position-relative ns-mb-30">
      <div class="button-filter-wrapper">
        <div *ngIf="selectedRegionTags.length > 0 || selectedTopicTags.length > 0 || selectedVettingType !== undefined"
             class="active-filter-dot"></div>
        <ns-button
          (callback$)="toggleFilters()"
          [classes]="'ns-height-32 ns-ml-20 ns-p-14x5 ns-font-12 ns-b-radius-5'"
          [faIcon]="'fa-solid fa-sliders'"
          [iconClasses]="'ns-mr-10'"
          [iconRightSide]="false"
          [isActive]="selectedRegionTags.length > 0 || selectedTopicTags.length > 0 || selectedVettingType !==
                  undefined"
          [styles]="'min-width: 105px;'"
          [text]="'BROWSE_PAGE.filter' | translate"
          [type]="Constants.BUTTON_TYPE_DEFAULT_DARK_BLUE_STROKE_M">
        </ns-button>
      </div>
      <ns-button
        (callback$)="onOpenCloseSortContextMenu()"
        *ngIf="isPledge"
        [classes]="'ns-height-32 ns-ml-20 ns-p-14x5 ns-font-12 ns-b-radius-5'"
        [faIcon]="'fa-solid fa-sort'"
        [iconClasses]="'ns-mr-10'"
        [iconRightSide]="false"
        [isActive]="isSortContextMenuOpen"
        [styles]="'min-width: 105px;'"
        [text]="'BROWSE_PAGE.sort_by' | translate"
        [type]="Constants.BUTTON_TYPE_DEFAULT_DARK_BLUE_STROKE_M">
      </ns-button>
      <div *ngIf="isSortContextMenuOpen" class="context-menu">
        <div (click)="setSorting(ProjectConstants.SORT_BY_RELEVANT)" class="radio-option">
          <i [ngClass]="{
            'fa-circle': selectedSortingOption !== ProjectConstants.SORT_BY_RELEVANT,
            'fa-circle-dot': selectedSortingOption === ProjectConstants.SORT_BY_RELEVANT}" class="fa-regular"></i>
          <label>{{ 'BROWSE_PAGE.most_relevant' | translate }}</label>
        </div>
        <div (click)="setSorting(ProjectConstants.SORT_BY_DATE)" class="radio-option">
          <i [ngClass]="{
            'fa-circle': selectedSortingOption !== ProjectConstants.SORT_BY_DATE,
            'fa-circle-dot': selectedSortingOption === ProjectConstants.SORT_BY_DATE}" class="fa-regular"></i>
          <label>{{ 'BROWSE_PAGE.newest' | translate }}</label>
        </div>
        <div (click)="setSorting(ProjectConstants.SORT_BY_VOTES)" class="radio-option">
          <i [ngClass]="{
            'fa-circle': selectedSortingOption !== ProjectConstants.SORT_BY_VOTES,
            'fa-circle-dot': selectedSortingOption === ProjectConstants.SORT_BY_VOTES}" class="fa-regular"></i>
          <label>{{ 'BROWSE_PAGE.most_voted' | translate }}</label>
        </div>
      </div>
    </div>
    <div class="north-star-intro">
      <img *ngIf="selectedNorthStar !== ProjectConstants.CAT_ALL" alt="{{ selectedNorthStar }}" loading="lazy"
           src="/assets/icons/north_star/{{ selectedNorthStar }}_selected.svg">
      <img *ngIf="selectedNorthStar === ProjectConstants.CAT_ALL" alt="all" class="icon-all" loading="lazy"
           src="/assets/icons/very-light-green-logo.svg">
      <div class="north-star-intro-right">
        <div
          class="north-star-intro-title">{{ "BROWSE_PAGE.title_" + selectedNorthStar + "_browsepage" | translate }}</div>
        <div
          class="north-star-intro-text">{{ "BROWSE_PAGE.text_" + selectedNorthStar + "_browsepage" | translate }}</div>
      </div>
    </div>

    <!-- SORTING -->
    <div *ngIf="!isMobile && isPledge" class="sort-button-container">
      <button (click)="onOpenCloseSortContextMenu()" [class.active]="isSortContextMenuOpen" class="sort-button">
        {{'BROWSE_PAGE.sort_by' | translate }}
        <i class="fa-solid fa-caret-down"></i>
      </button>
      <div *ngIf="isSortContextMenuOpen" class="context-menu">
        <div (click)="setSorting(ProjectConstants.SORT_BY_RELEVANT)" class="radio-option">
          <i [ngClass]="{
            'fa-circle': selectedSortingOption !== ProjectConstants.SORT_BY_RELEVANT,
            'fa-circle-dot': selectedSortingOption === ProjectConstants.SORT_BY_RELEVANT}" class="fa-regular"></i>
          <label>{{ 'BROWSE_PAGE.most_relevant' | translate }}</label>
        </div>
        <div (click)="setSorting(ProjectConstants.SORT_BY_DATE)" class="radio-option">
          <i [ngClass]="{
            'fa-circle': selectedSortingOption !== ProjectConstants.SORT_BY_DATE,
            'fa-circle-dot': selectedSortingOption === ProjectConstants.SORT_BY_DATE}" class="fa-regular"></i>
          <label>{{ 'BROWSE_PAGE.newest' | translate }}</label>
        </div>
        <div (click)="setSorting(ProjectConstants.SORT_BY_VOTES)" class="radio-option">
          <i [ngClass]="{
            'fa-circle': selectedSortingOption !== ProjectConstants.SORT_BY_VOTES,
            'fa-circle-dot': selectedSortingOption === ProjectConstants.SORT_BY_VOTES}" class="fa-regular"></i>
          <label>{{ 'BROWSE_PAGE.most_voted' | translate }}</label>
        </div>
      </div>
    </div>
    <!--#endregion -->
    <!--#region PROJECTS -->
    <div class="projects">
      <div (click)="openProposeProjectModal()" *ngIf="isPledge && ownMoneyDataReady" class="propose-box">
        <i class="fa fa-plus"></i>
        <div class="text">
          {{ 'BROWSE_PAGE.propose_project' | translate }}
        </div>
      </div>
      <ng-container *ngFor="let project of displayedProjects">
        <app-project-card
          (click)="openProjectDialog(project)"
          *ngIf="ownMoneyDataReady"
          [continent]='"PREFERENCES_POPUP_2." + project.continent + "_preferencespopup2" | translate'
          [country]='"COUNTRIES." + project.country | translate'
          [id]="project.id"
          [imgUrl]="project.picture_thumbnail"
          [isSupported]="isVoted(project.id)"
          [name]="project.name[currentLanguage]"
          [northStar2]="project.north_star_2"
          [northStar3]="project.north_star_3"
          [northStar]="project.north_star"
          [organization]="project.organization"
          [ownMoneyProjects]="ownMoneyProjects"
          [slug]="project.slug"
          [vettedBy]="project.vetted_by">
        </app-project-card>
      </ng-container>
    </div>

    <div *ngIf="paginationLimit < filteredProjects?.length" class="button-wrapper">
      <ns-button
        (callback$)="showMore()"
        [text]="'BROWSE_PAGE.see_more_browsepage' | translate"
        [type]="Constants.BUTTON_TYPE_DEFAULT_GREEN_FILLED_B">
      </ns-button>
    </div>
    <!--#endregion -->
  </div>
  <!--#region FILTERS SIDEBAR -->
  <div [ngClass]="{'show': showFilters}" class="sidebar-wrapper">
    <div (click)="toggleFilters()" class="backdrop"></div>
    <div class="sidebar">
      <div class="top-container">
        <i class="fa-solid fa-sliders"></i>
        <div class="title">{{ "BROWSE_PAGE.filter" | translate }}</div>
        <i (click)="toggleFilters()" class="fa-solid fa-angle-left"></i>
      </div>
      <!-- FILTER Vetted by -->
      <ng-container *ngIf="isPledge">
        <div class="filter-section">
          <div class="filter-title">{{ "BROWSE_PAGE.vetted_by" | translate }}</div>
          <ns-button
            (callback$)="clearVettingTypeFilter()"
            [classes]="'ns-font-w-700'"
            [text]="'BROWSE_PAGE.clear' | translate"
            [type]="Constants.BUTTON_TYPE_DEFAULT_DARK_BLUE_GHOST_S">
          </ns-button>
        </div>
        <div class="options-container">
          <div (click)="filterByVettedType(ProjectConstants.VETTED_BY_NOOS)"
               [class.active]="selectedVettingType === ProjectConstants.VETTED_BY_NOOS"
               [class.disabled]="vettedByUsCount === 0"
               class="option">
            {{ 'BROWSE_PAGE.noos_curated' | translate }}
          </div>
          <div (click)="filterByVettedType(ProjectConstants.VETTED_BY_EMPLOYEE)"
               [class.active]="selectedVettingType === ProjectConstants.VETTED_BY_EMPLOYEE"
               [class.disabled]="vettedByEmployeesCount === 0"
               class="option">
            {{ 'BROWSE_PAGE.employee_recommended' | translate }}
          </div>
        </div>
      </ng-container>
      <!-- FILTER Region -->
      <div class="filter-section ns-mt-38">
        <div class="filter-title">{{ 'BROWSE_PAGE.region' | translate }}</div>
        <ns-button
          (callback$)="clearRegionFilter()"
          [classes]="'ns-font-w-700'"
          [text]="'BROWSE_PAGE.clear' | translate"
          [type]="Constants.BUTTON_TYPE_DEFAULT_DARK_BLUE_GHOST_S">
        </ns-button>
      </div>
      <div>
        <div class="tag-filter-container">
          <div (click)="setRegionFilterFranceOnly(true)" class="tag-filter ns-mr-24">
            <i [ngClass]="{
            'fa-circle': !isRegionFilterFranceOnly,
            'fa-circle-dot': isRegionFilterFranceOnly}" class="fa-regular"></i>
            <label>{{ 'BROWSE_PAGE.france' | translate }}</label>
          </div>
          <div (click)="setRegionFilterFranceOnly(false)" class="tag-filter">
            <i [ngClass]="{
            'fa-circle': isRegionFilterFranceOnly,
            'fa-circle-dot': !isRegionFilterFranceOnly}" class="fa-regular"></i>
            <label>{{ 'BROWSE_PAGE.other_regions' | translate }}</label>
          </div>
        </div>
      </div>
      <div class="options-container">
        <div (click)="filterByTag(tagInfo)" *ngFor="let tagInfo of filteredRegionTagsInfo"
             [class.active]="isRegionTagSelected(tagInfo.tag)"
             [class.disabled]="tagInfo.itemsNumber === 0 && !isRegionFilterAvailable(tagInfo)"
             class="option">
          {{ tagInfo.tag.tag[currentLanguage] }}
        </div>
      </div>
      <!-- FILTER Topic -->
      <div class="filter-section ns-mt-38">
        <div class="filter-title">{{ 'BROWSE_PAGE.topic' | translate }}</div>
        <ns-button
          (callback$)="clearTopicFilter()"
          [classes]="'ns-font-w-700'"
          [text]="'BROWSE_PAGE.clear' | translate"
          [type]="Constants.BUTTON_TYPE_DEFAULT_DARK_BLUE_GHOST_S">
        </ns-button>
      </div>
      <div class="options-container">
        <div (click)="filterByTag(tagInfo)" *ngFor="let tagInfo of topicsTagsInfo"
             [class.active]="isTopicTagSelected(tagInfo.tag)"
             [class.disabled]="tagInfo.itemsNumber === 0 && !isTopicFilterAvailable(tagInfo)"
             class="option">
          {{ tagInfo.tag.tag[currentLanguage] }}
        </div>
      </div>
    </div>
  </div>
  <!--#endregion -->
